<template>
  <div class="car-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车辆牌照</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入车辆牌照" v-model="table.search.license"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>手机号码</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入手机号码" v-model="table.search.phone"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择状态">
              <a-select-option :value="0">{{carStatusText(0)}}</a-select-option>
              <a-select-option :value="1">{{carStatusText(1)}}</a-select-option>
              <a-select-option :value="2">{{carStatusText(2)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.status === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="reviewCar(data)" v-if="!data.state">审核</a-button>
          <a-button type="link" @click="scanCar(data)" v-else>查看</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <car-info :id="drawer.id" :is-scan="drawer.isScan" :is-review="drawer.isReview" @confirm="carInfoConfirm"></car-info>
    </a-drawer>
  </div>
</template>

<script>
  import {
    carStatusText
  } from '@/io/dict.js';
  import CarService from '@/io/car.js';
  import CarInfo from '@/views/platform/CarInfo.vue';

  export default {
    name: 'CarManage',
    data() {
      let self = this;
      return {
        carStatusText,
        table: {
          loading: false,
          search: {
            license: null,
            phone: null,
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '车辆牌照',
              dataIndex: 'car_number'
            },
            {
              title: '车主姓名',
              dataIndex: 'car_owner_name'
            },
            {
              title: '车主电话',
              dataIndex: 'mobile'
            },
            {
              title: '状态',
              dataIndex: 'carStatusText'
            },
            {
              title: '创建时间',
              dataIndex: 'created_at'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        drawer: {
          id: null,
          title: '车辆详情',
          show: false,
          isScan: false,
          isReview: false
        }
      }
    },
    activated() {
      this.initData();
    },
    components: {
      CarInfo,
    },
    methods: {
      carInfoConfirm() {
        this.drawer.show = false;
        this.initData();
      },
      scanCar(data) {
        this.drawer.id = data.id;
        this.drawer.isScan = true;
        this.drawer.isReview = false;
        this.drawer.show = true;
      },
      reviewCar(data) {
        this.drawer.id = data.id;
        this.drawer.isScan = false;
        this.drawer.isReview = true;
        this.drawer.show = true;
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          account: null,
          name: null,
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return CarService.listPage(
          this.table.search.license,
          this.table.search.phone,
          this.table.search.status,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.carStatusText = carStatusText(val.state);
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>